import axios, { AxiosRequestConfig } from "axios"
import { useAuth } from "react-oidc-context";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const useBaseApi = () => {

  const auth = useAuth();

  const getHeaders = async () => {
    const token = auth.user?.access_token;
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  }

  const request = async <T>(method: string, endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
    try {
      const headers = await getHeaders();
      const response = await axios({
        method,
        url: `${API_BASE_URL}${endpoint}`,
        data,
        headers,
        ...config,
      });
      return response.data;
    } catch (error) {
      console.error(`API request error: ${method.toUpperCase()} ${endpoint}`, error);
      throw error;
    }
  }

  return { request }
}
